import React, { useState } from 'react';
import foodData from './foodData.json';
import SearchBar from './SearchBar';
import CategorySelector from './CategorySelector';
import FoodList from './FoodList';
import FoodDetail from './FoodDetail';
import './Food.css';

const Food = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedFood, setSelectedFood] = useState(null);

  const filteredFoods = selectedCategory === 'All'
    ? foodData
    : foodData.filter(item => item.category === selectedCategory);

  return (
    <div className="app-container">
      <h1>🍽️ Ingredient Lore</h1>
      <SearchBar foodItems={foodData} onSelect={setSelectedFood} />
       {selectedFood && <FoodDetail item={selectedFood} onClose={() => setSelectedFood(null)} />}
      <CategorySelector onSelect={setSelectedCategory} />
      <FoodList items={filteredFoods} onSelect={setSelectedFood} />
     
    </div>
  );
};

export default Food;
